import { _ } from '/@/locale';

export const generateUniques = (key: string, data) => {
    if (!data) return [];
    const uniqueOptionsMap = new Map();

    for (const option of data) {
        if (typeof option[key] === 'object' && option[key]?.id) {
            if (!uniqueOptionsMap.has(option[key].id)) {
                uniqueOptionsMap.set(option[key].id, {
                    label: _(option[key].name),
                    value: option[key].id,
                    ...option[key],
                });
            }
        } else if (option[key]) {
            if (!uniqueOptionsMap.has(option[key])) {
                uniqueOptionsMap.set(option[key], {
                    label: _(option[key]),
                    value: option[key],
                });
            }
        }
    }

    return Array.from(uniqueOptionsMap.values());
};
